import { useQuery } from '@tanstack/react-query';
import { companyRegistrySearchOptions } from 'generated/api-client/@tanstack/react-query.gen';
import { useDebounce } from 'use-debounce';

type Options = {
  searchText?: string;
  siren?: string;
};

export const useCompanyRegistrySearch = ({ searchText, siren }: Options) => {
  const [debouncedSearchText] = useDebounce(searchText, 600);

  const enabled = !!debouncedSearchText || !!siren;

  const { data: results, isLoading } = useQuery({
    ...companyRegistrySearchOptions({
      query: { searchText: debouncedSearchText, siren },
    }),
    enabled,
  });

  const isDebouncing = !!searchText && searchText !== debouncedSearchText;

  return { results, isLoading: isLoading || isDebouncing };
};
